export const hasContentWithoutPlaytime = (cmArr, screenType) => {
  const normalizedCmArr =
    screenType === 'theatre' ? cmArr : cmArr.filter(({ entityType }) => entityType !== 'programme');

  return normalizedCmArr.some(cm => {
    if (Array.isArray(cm)) return hasContentWithoutPlaytime(cm, screenType);
    return !cm._playtime.length; // eslint-disable-line
  });
};